module.exports = __webpack_public_path__ + "img/logo.e72fc69a.png";